import { selectProduct } from "@/store/slices/product";
import React from "react";
import { useSelector } from "react-redux";

const ProductDetailsDescriptionTab = () => {
  const productState = useSelector(selectProduct);

  if (!productState.data) {
    return <></>;
  }

  return (
    <>
      <div className="details_text">
        <p>{productState.data.description}</p>

        {productState.data.disclaimer && (
          <p style={{ display: "block" }}>
            <strong>Disclaimer:</strong>{" "}
            <span style={{ fontSize: 14, color: "rgb(87, 87, 87)" }}>
              {productState.data.disclaimer}
            </span>
          </p>
        )}
      </div>
    </>
  );
};

export default ProductDetailsDescriptionTab;
